<script setup>
import { useI18n } from "vue-i18n"
import { languages } from "@/enums/enums.js"

const { locale, t } = useI18n()

const setLanguage = (lang) => {
    locale.value = lang
    localStorage.setItem("locale", lang)
}
</script>

<template>
    <div class="language-switch text-end mt-3">
        <button
            v-for="lang in languages"
            :key="lang.code"
            class="me-2"
            @click="setLanguage(lang.code)"
            :class="{ 'fw-bold': lang.code === locale }"
        >
            <img
                :src="lang.flag"
                :alt="lang.alt"
                width="20"
                height="20"
            />
            {{ lang.label }}
        </button>
    </div>
</template>
